    import React, { useEffect } from "react";
    import { navigate, useQueryParams, useRoutes, usePath } from "raviger";
    import * as auth from "../backend/auth";
    import { useLocationChange } from 'raviger';
    import PageNotFound from "../components/shared/PageNotFound";
    import VendorDashboard from "../components/pages/Vendor/Dashboard/Dashboard";
    import VendorAuditDashboard from "../components/pages/VendorAudit/VendorAuditDashboard";
    import VendorAuditDashboardV2 from "../components/pages/VendorAuditV2/VendorAuditDashboardV2";
    import ActivitiesManagement from "../components/pages/Vendor/TaskManagement/ActivitiesManagement";
    import ActivitiesManagementV2 from "../components/pages/Vendor/TaskManagement/ActivitiesManagementV2";
    import LayoutWithSideNav from "../components/shared/LayoutWithSideNav";
    import AuditorDashboard from "../components/pages/Auditor/AuditorDashboard";
    import LocationAuditDashboard from "../components/pages/Auditor/LocationAuditDashboard";
    import TaskManagement from "../components/pages/Auditor/TaskManagement";
    import TaskManagementV2 from "../components/pages/Auditor/TaskManagementV2";
    import Law from "../components/pages/Masters/Laws/ManageLaws";
    import Act from "../components/pages/Masters/Acts/ManageActs";
    import Activity from "../components/pages/Masters/Activities/ManageActivities";
    import Rule from "../components/pages/Masters/Rules/ManageRules";
    import Location from "../components/pages/Masters/Locations/ManageLocations";
    import City from "../components/pages/Masters/Cities/ManageCities";
    import State from "../components/pages/Masters/States/ManageStates";
    import ChangePassword from "../components/pages/Authenticate/ChangePassword";
    import Login from "../components/pages/Authenticate/Login";
    import SSOLogin from "../components/pages/Authenticate/SSOLogin";
    import SSOCallback from "../components/pages/Authenticate/SSOCallback";
    import UnlockAccount from "../components/pages/Authenticate/UnlockAccount";
    import Navbar from "../components/shared/Navbar";
    import RuleStateCompanyMapping from "../components/pages/Masters/Mappings/RuleStateCompanyMapping";
    import MangeUsers from "../components/pages/UserManagement/ManageUsers";
    import AssociateCompanies from "../components/pages/Masters/Companies/AssociateCompanies";
    import Companies from "../components/pages/Masters/Companies/Companies";
    import CompanyLocationMappings from "../components/pages/Masters/Companies/CompanyLocationMappings";
    import UserCompanies from "../components/pages/UserManagement/UserCompanies";
    import AuditSchedule from "../components/pages/Masters/Companies/AuditSchedule";
    import AuditScheduleDetails from "../components/pages/Masters/Companies/AuditScheduleDetails";
    import LockUnLock from "../components/pages/Masters/Companies/LockUnLock";
    import EmailTemplates from "../components/pages/Email/EmailTemplates";
    import Home from "../components/pages/home";
    import Roles from "../components/pages/UserManagement/Roles/Roles";
    import ManageVerticals from "../components/pages/Masters/Companies/Verticals/ManageVerticals";
    import ManageDepartments from "../components/pages/Masters/Companies/Departments/ManageDepartments";
    import ComplianceSchedule from "../components/pages/ComplianceMasters/ComplianceSchedule";
    import ComplianceScheduleDetails from "../components/pages/ComplianceMasters/ComplianceScheduleDetails";
    import { USER_PRIVILEGES } from "../components/pages/UserManagement/Roles/RoleConfiguration";
    import ComplianceOwnerDashboard from "../components/pages/ComplianceOwner/Dashboard/ComplianceOwnerDashboard";
    import ComplianceDashboardV2 from "../components/pages/ComplianceOwner/DashboardV2/ComplianceDashboardV2";
    import ComplianceListingV2 from "../components/pages/ComplianceOwner/DashboardV2/ComplianceListingV2";
    import MangeDepartmentUsers from "../components/pages/UserManagement/DepartmentUsers.tsx/ManageDepartmentUsers";
    import ComplianceOwnerActivities from "../components/pages/ComplianceOwner/TaskManagement/ComplianceOwnerActivities";
    import NotificationsCenter from "../components/pages/Notifications/NotificationsCenter";
    import ManageEscalationMatrix from "../components/pages/Masters/Companies/EscalationMatrix/ManageEscalationMatrix";
    import NotificationTemplates from "../components/pages/Notifications/NotificationTemplates";
    import ManageNotices from "../components/pages/Notices/ManageNotices";
    import EmployeeMasterUpload from "../components/pages/InputModule/EmployeeMasterUpload";
    import HolidayList from "../components/pages/InputModule/HolidayList";
    import LeaveConfiguration from "../components/pages/InputModule/LeaveConfiguration";
    import LeaveMapping from "../components/pages/InputModule/Dashboard";
    import AttendanceConfig from "../components/pages/InputModule/AttendanceConfig";
    import StateRegisterConfiguration from "../components/pages/InputModule/StateRegisterConfiguration";
    import EmployeeLeaveCreditUpload from "../components/pages/InputModule/EmployeeLeaveCreditUpload";
    import EmployeeLeaveAvailedUpload from "../components/pages/InputModule/EmployeeLeaveAvailedUpload";
    import EmployeeAttendanceUpload from "../components/pages/InputModule/EmployeeAttendanceUpload";
    import SalaryComponents from "../components/pages/InputModule/SalaryComponents";
    import Dashboard from "../components/pages/InputModule/Dashboard";
    import Configurations from "../components/pages/InputModule/Configurations";
    import EmployeeWageUpload from "../components/pages/InputModule/EmployeeWageUpload";
    import RegisterDownload from "../components/pages/InputModule/RegisterDownload";
    import InputsDashboard from "../components/pages/InputModule/Dashboard";
    import RegistersQue from "../components/pages/InputModule/RegistersQue";
    //import QueRegisterDownload from "../components/pages/InputModule/QueRegisterDownload";
    import VendorCategories from "../components/pages/Masters/VendorCategories/ManageVendorCategories";

    import Vendors from "../components/pages/Masters/Companies/Vendors";
    import VendorLocationActivitiesManagement from "../components/pages/Vendor/TaskManagement/VendorLocationActivitesManagementV2";
    //import VendorAuditSchedule from "../components/pages/Masters/Companies/VendorAuditSchedule";
    import VendorAuditSchedule from "../components/pages/Masters/Companies/VendorAuditSchedule";
    import VendorAuditScheduleDetails from "../components/pages/Masters/Companies/VendorAuditScheduleDetials";
    import VendorLockUnLock from "../components/pages/Masters/Companies/VendorLockNUnlock";
    import UserVendors from "../components/pages/UserManagement/UserVendors";
    import CompanyVendorLocationMappings from "../components/pages/Masters/Companies/CompanyVendorLocationMappings";
    import LicenseDashboard from "../components/pages/LicenseManagement/Dashboard/Dashboard";
    import LicenseTypes from "../components/pages/LicenseManagement/LicenseType/LicenseType";
    import LicenseApplications from "../components/pages/LicenseManagement/LicenseApplication/LicenseApplication";
    import NoticesDashboard from "../components/pages/NoticeManagement/Notices/NoticesDashboard";
    import LitigationDashboard from "../components/pages/NoticeManagement/Litigations/LitigationsDashboard";
    import VendorAuditList from "../components/pages/Vendor/TaskManagement/VendorAuditList";
    import AuditList from "../components/pages/Vendor/TaskManagement/AuditList";
    import AuditListV2 from "../components/pages/Vendor/TaskManagement/AuditListV2";
    import S3FileDownload from "../components/pages/S3FileDownload/S3FileDownload";
    import PerformerClientFieldMapping from "../components/pages/PerformerClientAdmin/FieldMapping/FieldMapping";
    import PerformerClientEmployeeMasterUpload from "../components/pages/PerformerClientAdmin/Uploads/EmployeeMasterUpload";
    import PerformerClientEmployeeLeaveCreditUpload from "../components/pages/PerformerClientAdmin/Uploads/EmployeeLeaveCreditUpload";
    import PerformerClientEmployeeLeaveAvailedUpload from "../components/pages/PerformerClientAdmin/Uploads/EmployeeLeaveAvailedUpload";
    import PerformerClientEmployeeAttendanceUpload from "../components/pages/PerformerClientAdmin/Uploads/EmployeeAttendanceUpload";
    import PerformerClientEmployeeWageUpload from "../components/pages/PerformerClientAdmin/Uploads/EmployeeWageUpload";
    import PerformerClientRegistersQueue from "../components/pages/PerformerClientAdmin/Registers/RegistersQueue";
    import PerformerClientHolidayList from "../components/pages/PerformerClientAdmin/HolidayList/HolidayList";
    import ModuleNotSubscribed from "../components/common/ModuleNotSubscribed";

    export const ROLE_MAPPING: any = {
        AuditorAdmin: ['dashboard', 'activities'],
        AuditorUser: ['dashboard', 'activities'],
        VendorAdmin: ['dashboard', 'activities'],
        VendorUser: ['dashboard', 'activities'],
        SuperAdmin: ['masters', 'companies', 'auditSchedule', 'userManagement', 'email']
    }

    function AuthenticatedContent() {
        const currentPath = usePath(); // MUST be first — keeps component subscribed to URL changes even if we early-return below
        const [query] = useQueryParams();

        // Initialize tab session synchronously before rendering
        // This ensures duplicated tabs have role set before privilege checks
        auth.initializeTabSession();

        // `getAuthToken()` reads the shared (cross-tab) localStorage token live on every render,
        // so a tab left open when another tab logs out/re-logs-in would otherwise flip `hasToken`
        // false the instant that happens — swapping this tab straight to <Login/> mid-render
        // (no navigate, so the URL never actually changes — see PageNotFound-style guards below)
        // and then flipping back once the other tab's new token lands, remounting the layout with
        // a mismatched identity (new token, this tab's own stale cached role). `isSessionInvalidated()`
        // is set by that same cross-tab change (see auth.ts) and stays true until this tab's own
        // request interceptor (request.ts) actually processes a real user-initiated action — so
        // treating it as "still has a token" here keeps this tab frozen on its current page until then.
        const hasToken = !!auth.getAuthToken() || auth.isSessionInvalidated();

        const PUBLIC_PATHS = ['/login', '/sso-login', '/auth/callback', '/unlock', '/users/password/edit'];
        const isPublicPath = PUBLIC_PATHS.some(p => currentPath === p || (currentPath && currentPath.endsWith(p)));

        function layout(children: any, layoutWithSidenav = true, requiredPrivilege?: string | string[]) {
            // Check if privilege is required and user has access
            if (requiredPrivilege) {
                const privileges = Array.isArray(requiredPrivilege) ? requiredPrivilege : [requiredPrivilege];
                const hasAccess = privileges.some(privilege => auth.hasUserAccess(privilege));

                if (!hasAccess) {
                    navigate('/');
                    // return null;
                }
            }

            if (layoutWithSidenav) {
                return <LayoutWithSideNav>{children}</LayoutWithSideNav>
            }
            return <>{children}</>
        }

        function getHomePage() {
            if (!hasToken) {
                return <Login />
            } else {
                if (auth.hasUserAccess(USER_PRIVILEGES.VENDOR_AUDIT_DASHBOARD)) {
                    navigate("/vendor-audit-dashboard")
                    return <></>;
                } else if (auth.hasUserAccess(USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD)) {
                    navigate("/location-audit-dashboard")
                    return <></>;
                } else if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_DASHBOARD)) {
                    navigate("vendor-audits") 
                    return <></>;
                } else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_DASHBOARD)) {
                    navigate("vendor-audits")
                    return <></>;
                } else if (
                    auth.hasUserAccess(USER_PRIVILEGES.OWNER_DASHBOARD) ||
                    auth.hasUserAccess(USER_PRIVILEGES.MANAGER_DASHBOARD) ||
                    auth.hasUserAccess(USER_PRIVILEGES.ESCALATION_DASHBOARD)
                ) {
                    navigate('/complianceManagement/compliance-dashboard');
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.VIEW_LICENSE_DASHBOARD)) {
                    navigate("license-management/licenses")
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.VIEW_NOTICES_DASHBOARD) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_MANAGER) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_OWNER) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_WATCHER)) {
                    navigate("notice-management/notices")
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.PERFORMER_CLIENT_DASHBOARD)) {
                    navigate("performerClient/setupInput/fieldMapping")
                    return <></>;
                }
                // else if (auth.hasUserAccess(USER_PRIVILEGES.INPUT_DASHBOARD)) {
                //     return layout(<InputsDashboard />);
                // }
                else {
                    return layout(<Home />)
                }
            }
        }

        function getDashboardPage() {
            if (!hasToken) {
                return <Login />
            } else {
                if (auth.hasUserAccess(USER_PRIVILEGES.VENDOR_AUDIT_DASHBOARD)) {
                    navigate('/vendor-audit-dashboard');
                    return <></>;
                } else if (auth.hasUserAccess(USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD)) {
                    navigate('/location-audit-dashboard');
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_DASHBOARD)) {
                    navigate('/location-audit-dashboard');
                    return <></>;
                } else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_DASHBOARD)) {
                    navigate('/location-audit-dashboard');  
                    return <></>;
                }
                // OTHER DASHBOARDS
                else if (
                    auth.hasUserAccess(USER_PRIVILEGES.OWNER_DASHBOARD) ||
                    auth.hasUserAccess(USER_PRIVILEGES.MANAGER_DASHBOARD) ||
                    auth.hasUserAccess(USER_PRIVILEGES.ESCALATION_DASHBOARD)
                ) {
                    navigate('/complianceManagement/compliance-dashboard');
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.VIEW_LICENSE_DASHBOARD)) {
                    navigate("license-management/licenses")
                    return <></>;
                }
                else if (auth.hasUserAccess(USER_PRIVILEGES.VIEW_NOTICES_DASHBOARD) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_MANAGER) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_OWNER) ||
                         auth.hasUserAccess(USER_PRIVILEGES.NOTICE_WATCHER)) {
                    navigate("notice-management/notices")
                    return <></>;
                }
                else {
                    return layout(<Home />)
                }
            }
        }
//newly added
        function getActivitiesByRole(url:string) {
            if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES)) {
                // return layout(<AuditList />);
                return layout(<AuditListV2 />);
            }
            else if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES)) {
                return layout(<VendorAuditList />);
            }
            else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES)) {
                // return layout(<AuditList />);
                return layout(<AuditListV2 />);
            }
            else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES)) {
                return layout(<TaskManagement urlPath={url}/>);
            } else if (auth.hasUserAccess(USER_PRIVILEGES.OWNER_DASHBOARD)) {
                return layout(<ComplianceOwnerActivities />);
            } else if (auth.hasUserAccess(USER_PRIVILEGES.MANAGER_DASHBOARD)) {
                // return layout(<VendorDashboard />);
                return layout(<VendorAuditDashboard />);
            } else {
                return layout(<ModuleNotSubscribed />)
            }
        }

        //old method
        // function getActivitiesByRole(url:string) {
        //     if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES)) {
        //         return layout(<ActivitiesManagement />);
        //     } 
        //     else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES)) {
        //         return layout(<TaskManagement urlPath={url}/>);
        //     } else if (auth.hasUserAccess(USER_PRIVILEGES.OWNER_DASHBOARD)) {
        //         return layout(<ComplianceOwnerActivities />);
        //     } else if (auth.hasUserAccess(USER_PRIVILEGES.MANAGER_DASHBOARD)) {
        //         return layout(<VendorDashboard />);
        //     } else {
        //         return layout(<></>)
        //     }
        // }
        function getVendorAuditDashboardPage() {
            if (!hasToken) {
                return <Login />
            }

            if (auth.hasUserAccess(USER_PRIVILEGES.VENDOR_AUDIT_DASHBOARD)) {
                // old dashboard
                //return layout(<VendorAuditDashboard />);    
                return layout(<VendorAuditDashboardV2 />);
            } else {
                return layout(<ModuleNotSubscribed />);
            }
        }

        function getLocationAuditDashboardPage() {
            if (!hasToken) {
                return <Login />
            }

            if (auth.hasUserAccess(USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD)) {
                //                 // Check user role/privilege to determine which dashboard to show
                // if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES) ||
                //     auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_DASHBOARD)) {
                //     // Auditor role: Show AuditorDashboard
                //     return layout(<AuditorDashboard />);
                // } else if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES) ||
                //             auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_DASHBOARD)) {
                //     // Vendor role: Show VendorDashboard
                //     return layout(<VendorDashboard />);
                // } else {
                //     // Fallback: Show VendorDashboard
                //     return layout(<VendorDashboard />);
                // }
                return layout(<LocationAuditDashboard />);
            } else {
                return layout(<ModuleNotSubscribed />);
            }
        }

        const routes = {
            '/dashboard': () => getDashboardPage(),
            '/dashboard/activities': () => (
                // layout(<AuditList />)
                layout(<AuditListV2 />)
            ),
            "/vendor-audits/:auditId": ({auditId}: any) =>
                layout(<VendorLocationActivitiesManagement auditId={auditId} />),
            "/vendor-audits": () =>
                layout(<VendorAuditList />),
            "/location-audits/:auditId": ({auditId}: any) => {
                if (auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES)) {
                    // return layout(<ActivitiesManagement auditId={auditId} />);
                    return layout(<ActivitiesManagementV2 auditId={auditId} />);
                } else if (auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES)) {
                    // return layout(<TaskManagement auditId={auditId} />);
                    return layout(<TaskManagementV2 auditId={auditId} />);
                } else {
                    navigate('/location-audits');
                    return <></>;
                }
            },
            '/vendor-audit-dashboard': getVendorAuditDashboardPage,
            '/vendor-audit-dashboard-v2': () => {
                if (!hasToken) return <Login />;
                // old dashboard
                //return layout(<VendorAuditDashboardV2 />);
                return layout(<VendorAuditDashboard />);
            },
            '/location-audit-dashboard': getLocationAuditDashboardPage,
            '/location-audits': () => getActivitiesByRole('empty'),
            '/inputUploads/dashboard': () => layout(<Dashboard />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_DASHBOARD),
            '/inputUploads/registersQue': () => layout(<RegistersQue />, true, USER_PRIVILEGES.VIEW_REGISTER_QUE),
            '/setupInput/inputModuleUploads': () => layout(<Configurations />, true, USER_PRIVILEGES.VIEW_INPUT_MODULE_UPLOAD),
            '/setupInput/holidayList': () => layout(<HolidayList />, true, USER_PRIVILEGES.VIEW_HOLIDAY_LIST),
            '/setupInput/leaveConfiguration': () => layout(<LeaveConfiguration />, true, USER_PRIVILEGES.VIEW_LEAVE_CONFIGURATION),
            '/setupInput/attendanceConfig': () => layout(<AttendanceConfig />, true, USER_PRIVILEGES.VIEW_ATTENDANCE_CONFIGURATION),
            '/setupInput/salaryComponents': () => layout(<SalaryComponents />, true, USER_PRIVILEGES.VIEW_SALARY_COMPONENTS),
            '/setupInput/stateRegisterConfiguration': () => layout(<StateRegisterConfiguration />, true, USER_PRIVILEGES.VIEW_STATEREGISTER_CONFIGURATION),
            '/inputUploads/employeeMasterUpload': () => layout(<EmployeeMasterUpload />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_MASTER),
            '/inputUploads/registerDownload' : () => layout(<RegisterDownload />, true, USER_PRIVILEGES.VIEW_REGISTER_DOWNLOAD),
            //'/inputUploads/queregisterDownload' : () => (layout(<QueRegisterDownload/>)),
            '/inputUploads/employeeLeaveCreditUpload': () => layout(<EmployeeLeaveCreditUpload />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_CREDIT),
            '/inputUploads/employeeLeaveAvailedUpload': () => layout(<EmployeeLeaveAvailedUpload />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_AVAILED),
            '/inputUploads/employeeAttendanceUpload': () => layout(<EmployeeAttendanceUpload />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_ATTENDANCE),
            '/inputUploads/employeeWageUpload': () => layout(<EmployeeWageUpload />, true, USER_PRIVILEGES.VIEW_EMPLOYEE_WAGE),

            '/performerClient/setupInput/fieldMapping': () => layout(<PerformerClientFieldMapping />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_FIELD_MAPPING),
            '/performerClient/employeeMasterUpload': () => layout(<PerformerClientEmployeeMasterUpload />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER),
            '/performerClient/employeeLeaveCreditUpload': () => layout(<PerformerClientEmployeeLeaveCreditUpload />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER),
            '/performerClient/employeeLeaveAvailedUpload': () => layout(<PerformerClientEmployeeLeaveAvailedUpload />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER),
            '/performerClient/employeeAttendanceUpload': () => layout(<PerformerClientEmployeeAttendanceUpload />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER),
            '/performerClient/employeeWageUpload': () => layout(<PerformerClientEmployeeWageUpload />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER),
            '/performerClient/registersQueue': () => layout(<PerformerClientRegistersQueue />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_REGISTER_QUE),
            '/performerClient/setupInput/holidayList': () => layout(<PerformerClientHolidayList />, true, USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_HOLIDAY_LIST),

            '/masters/law': () => (
                layout(<Law />)
            ),
            "/masters/vendor-categories": () => layout(<VendorCategories />),
            '/masters/act': () => (
                layout(<Act />)
            ),
            '/masters/activity': () => (
                layout(<Activity />)
            ),
            '/masters/rule': () => (
                layout(<Rule />)
            ),
            '/masters/state': () => (
                layout(<State />)
            ),
            '/masters/city': () => (
                layout(<City />)
            ),
            '/masters/location': () => (
                layout(<Location />)
            ),
            '/masters/mapping': () => (
                layout(<RuleStateCompanyMapping />)
            ),
            // License Management Routes

            '/license-management/licenses': () => (
                layout(<LicenseDashboard />
                )
            ),
            '/license-management/license-types': () => (
                layout(<LicenseTypes />)
            ),
            '/license-management/license-applications': () => (
                layout(<LicenseApplications />)
            ),
            '/notice-management/notices': () => (
                layout(<NoticesDashboard />, true, [
                    USER_PRIVILEGES.VIEW_NOTICES_DASHBOARD,
                    USER_PRIVILEGES.NOTICE_MANAGER,
                    USER_PRIVILEGES.NOTICE_OWNER,
                    USER_PRIVILEGES.NOTICE_WATCHER
                ])
            ),
            '/notice-management/litigations': () => (
                layout(<LitigationDashboard />, true, [
                    USER_PRIVILEGES.VIEW_LITIGATIONS_DASHBOARD,
                    USER_PRIVILEGES.NOTICE_MANAGER,
                    USER_PRIVILEGES.NOTICE_OWNER,
                    USER_PRIVILEGES.NOTICE_WATCHER
                ])
            ),
            '/companies/list': () => (
                layout(<Companies />)
            ),
            '/companies/associateCompanies': () => (
                layout(<AssociateCompanies />)
            ),
            "/companies/manageVendors": () => layout(<Vendors />),
            '/companies/verticals': () => (
                layout(<ManageVerticals />)
            ),
            '/companies/departments': () => (
                layout(<ManageDepartments />)
            ),
            '/companies/escalationMatrix': () => (
                layout(<ManageEscalationMatrix />)
            ),
            '/companies/locationMapping': () => (
                layout(<CompanyLocationMappings />)
            ),
            "/companies/vendor-location-mapping": () =>
                layout(<CompanyVendorLocationMappings />),
            '/companies/auditSchedule': () => (
                layout(<AuditSchedule />)
            ),
            '/auditSchedule/importExport': () => (
                layout(<AuditSchedule />)
            ),
            '/auditSchedule/details': () => (
                layout(<AuditScheduleDetails />)
            ),
            '/auditSchedule/blockUnblock': () => (
                layout(<LockUnLock />)
            ),
            "/vendor-audit-schedule/import-export": () =>
                layout(<VendorAuditSchedule />
            ),
            "/vendor-audit-schedule/details": () =>
                layout(<VendorAuditScheduleDetails />
            ),
            "/vendor-audit-schedule/block-unblock": () => 
                layout(<VendorLockUnLock />
            ),
            '/userManagement/roles': () => (
                layout(<Roles />)
            ),
            '/complianceManagement/complianceSchedule': () => (
                layout(<ComplianceSchedule />)
            ),
            '/complianceManagement/compliance-schedule-details': () => (
                layout(<ComplianceScheduleDetails />)
            ),
            '/complianceManagement/dashboard': () => layout(<ComplianceOwnerDashboard />, true, [USER_PRIVILEGES.OWNER_DASHBOARD, USER_PRIVILEGES.MANAGER_DASHBOARD, USER_PRIVILEGES.ESCALATION_DASHBOARD]),
            '/complianceManagement/compliance-dashboard': () => layout(<ComplianceDashboardV2 />, true, [USER_PRIVILEGES.OWNER_DASHBOARD, USER_PRIVILEGES.MANAGER_DASHBOARD, USER_PRIVILEGES.ESCALATION_DASHBOARD]),
            '/complianceManagement/list': () => layout(<ComplianceListingV2 />, true, [USER_PRIVILEGES.OWNER_DASHBOARD, USER_PRIVILEGES.MANAGER_DASHBOARD, USER_PRIVILEGES.ESCALATION_DASHBOARD]),
            '/userManagement/users': () => layout(<MangeUsers />, true, USER_PRIVILEGES.VIEW_USERS),
            '/userManagement/mapping': () => layout(<UserCompanies />, true, USER_PRIVILEGES.VIEW_COMPANY_MAPPINGS),
            "/userManagement/location-vendor-mapping": () => layout(<UserVendors />, true, USER_PRIVILEGES.VIEW_VENDOR_MAPPINGS),
            '/userManagement/userDepartment': () => layout(<MangeDepartmentUsers />, true, USER_PRIVILEGES.VIEW_DEPARTMENT_USER_MAPPING),
            '/templates/email': () => layout(<EmailTemplates />, true, USER_PRIVILEGES.VIEW_EMAIL_TEMPLATES),
            '/templates/notification': () => layout(<NotificationTemplates />, true, USER_PRIVILEGES.VIEW_NOTIFICATION_TEMPLATES),
            '/notifications': () => layout(<NotificationsCenter />, true, USER_PRIVILEGES.VIEW_NOTIFICATIONS),
            '/notices': () => layout(<ManageNotices />, true, USER_PRIVILEGES.VIEW_NOTICES),
            '/users/password/edit': () => (
                <ChangePassword />
            ),
            '/': () => (
                <>
                    {getHomePage()}
                </>
            ),
            '/login': () => (
                <Login />
            ),
            '/sso-login': () => (
                <SSOLogin />
            ),
            '/auth/callback': () => (
                <SSOCallback />
            ),
            '/unlock': () => (
                <UnlockAccount />
            ),
            '/s3_files/download': () => {
                if (!hasToken) {
                    // Store the current URL for redirect after login
                    const redirectUrl = window.location.pathname + window.location.search;
                    localStorage.setItem('redirectAfterLogin', redirectUrl);
                    return <Login />;
                }
                return <S3FileDownload />;
            }
        }

        useEffect(() => {
            if (query && query.redirectUri) {
                navigate(query.redirectUri);
            }
        }, [query]);

        useLocationChange(() => {
            const mainContainer = document.querySelector('.main-container');
            if (mainContainer) {
                mainContainer.scrollTop = 0;
            }
        });
        
        const route = useRoutes(routes, { basePath: '' })

        // All hooks have been called above — safe to conditionally return now.
        // Prevents ModuleNotSubscribed flash when session expires: authenticated routes
        // re-render with !hasToken before the logout redirect fires.
        if (!hasToken && !isPublicPath) return <Login />;

        return (
            <>
                {route || <PageNotFound />}
            </>
        );

    }

    export default AuthenticatedContent;
